import { useQuery } from '@apollo/client';
import type { ApolloQueryResult } from '@apollo/client';

import { StatusTypes, ListBankAccountsDocument } from 'src/gql/graphql';
import type { Exact, ListBankAccountsQuery as ListBankAccountsQueryResult, MxBankAccount } from 'src/gql/graphql';
import { Nullish } from 'shared/utils/type-utils';
import { AGGREGATORS } from 'src/payments/constants';

type UseBankAccountsUtils = {
  bankAccounts: (Pick<
    MxBankAccount,
    'accountAlias' | 'bankName' | 'billingAddressId' | 'entityId' | 'id' | 'lastDigits' | 'status'
  > & { _typename?: 'MxBankAccount' | undefined })[];
  connectionStatus: Nullish | string;
  mxWidgetUrl: Nullish | string;
  billingAddressId: Nullish | string;
  loading: boolean;
  statusAggregatorError: boolean;
  refetchBankAccountData: (
    variables?: Exact<{ aggregator: string }> | undefined
  ) => Promise<ApolloQueryResult<ListBankAccountsQueryResult>>;
};

export const useListBankAccounts = (): UseBankAccountsUtils => {
  const { data, refetch, loading } = useQuery(ListBankAccountsDocument, {
    variables: { aggregator: AGGREGATORS.MX },
    skip: true,
  });

  const bankAccounts = data?.listBankAccounts?.bankAccounts ?? [];
  const connectionStatus = bankAccounts[0]?.mx?.connectionStatus;
  const mxWidgetUrl = bankAccounts[0]?.mx?.widgetUrl;
  const billingAddressId = bankAccounts[0]?.billingAddressId;
  const statusAggregatorError = bankAccounts[0]?.status === StatusTypes.statusAggregatorError;
  const refetchBankAccountData = refetch;

  return {
    bankAccounts,
    connectionStatus,
    mxWidgetUrl,
    billingAddressId,
    statusAggregatorError,
    refetchBankAccountData,
    loading,
  };
};
